











































































import Vue from 'vue'
import Input from '@/components/Input.vue'
import Button from '@/components/Button.vue'
import SentIcon from '@/components/icons/SentIcon.vue'
import LoadingIcon from '@/components/icons/LoadingIcon.vue'
import FailedSendIcon from '@/components/icons/FailedSendIcon.vue'

export default Vue.extend({
  name: 'ContactForm',
  components: {
    Input,
    Button,
    SentIcon,
    LoadingIcon,
    FailedSendIcon
  },
  data() {
    return {
      messageStatus: 0,
      name: { value: '', error: '', touched: false },
      email: { value: '', error: '', touched: false },
      message: { value: '', error: '', touched: false },
      endpoint: 'https://formspree.io/xvovodwa',
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  watch: {
    'email.value'() {
      this.email.touched && this.validateEmail()
    },
    'name.value'() {
      this.name.touched && this.validateName()
    },
    'message.value'() {
      this.message.touched && this.validateMessage()
    }
  },
  methods: {
    async submitForm() {
      const data = {
        name: this.name.value,
        email: this.email.value,
        message: this.message.value
      }
      this.validateEmail()
      this.validateName()
      this.validateMessage()
      if (this.isFormReady()) {
        this.messageStatus = 1
        await this.$http
          .post(this.endpoint, data)
          .then(() => {
            this.name.value = ''
            this.email.value = ''
            this.message.value = ''
            this.messageStatus = 2
          })
          .catch(error => {
            if (error.response) {
              this.messageStatus = 3
            }
          })
      }
    },
    validateEmail() {
      this.email.touched = true
      this.email.error =
        this.email.value === ''
          ? 'Required field'
          : this.reg.test(this.email.value)
          ? ''
          : 'Invalid email'
    },
    validateName() {
      this.name.touched = true
      this.name.error = this.name.value === '' ? 'Required field' : ''
    },
    validateMessage() {
      this.message.touched = true
      this.message.error = this.message.value === '' ? 'Required field' : ''
    },
    isFormReady() {
      return (
        !this.name.error &&
        this.name.value &&
        !this.email.error &&
        this.email.value &&
        !this.message.error &&
        this.message.value
      )
    }
  }
})
